import { USER_LOGIN_REQUEST, USER_SUCCESS_LOGIN, USER_FAILED_LOGIN, LOGOUT} from "../actions/types";

let user = localStorage.getItem('token');
const initialState = user ? { loggedIn: true, loggedInError: null, user } : {};

export default function(state = initialState, action) {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { ...state, loggingIn: true, data: action.payload };
        case USER_SUCCESS_LOGIN:
            return { ...state, loggedIn: true, data: action.payload };
        case USER_FAILED_LOGIN:
            return { ...state, loggedInError: action.payload };
        case LOGOUT:
            return { };
        default:
            return state;
    }
  }
  



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js